export default "<div class=\"for-hire-wrapper\">\n  <div class=\"for-hire-hero\"></div>\n  <app-for-hire [isSkippers]=\"false\"></app-for-hire>\n</div>\n";